"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPolylineFieldProps = exports.withLocationFieldProps = exports.withBarcodeFieldProps = exports.withFileFieldProps = exports.withMediaFieldProps = exports.withTextareaFieldProps = exports.withTextHeaderProps = exports.withCurrencyFieldProps = exports.withTimeFieldProps = exports.withCheckboxProps = exports.withRadioFieldProps = exports.withAggregateSelectorFieldProps = exports.withSelectFieldProps = exports.withDateFieldProps = exports.withNumberFieldProps = exports.withTextFieldPropsComputed = exports.withTextFieldProps = void 0;
// @ts-nocheck
const react_1 = __importStar(require("react"));
const lodash_1 = __importStar(require("lodash"));
const client_1 = require("@apollo/client");
const client_2 = require("@apollo/client");
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const form_renderer_1 = require("@terragotech/form-renderer");
const configContext_1 = require("../../contexts/configContext");
const UserInfoContext_1 = require("../../contexts/UserInfoContext");
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const QueryDefinitionToGraphQLQuery_1 = require("../../utils/QueryDefinitionToGraphQLQuery");
const authContext_1 = require("../../contexts/authContext");
const common_1 = require("../../utils/common");
const DATA_COUNT_PER_PAGE = 100;
const getErrorAndWarningProps = ({ errors, warnings, }) => {
    let helperText = '';
    if (errors && errors[0]) {
        helperText = errors[0];
    }
    else if (warnings && warnings[0]) {
        helperText = warnings[0];
    }
    return {
        error: !!(errors && errors[0]),
        warning: warnings && warnings[0] ? true : undefined,
        helperText,
    };
};
const useFilterTextFieldProps = (props, type) => {
    const { value, onChange, controlDefinition, warnings, onFocus, onBlur, readOnly } = props;
    const { required, label, placeholder, info } = controlDefinition;
    const filteredProps = Object.assign(Object.assign({ type: type || 'text' }, getErrorAndWarningProps(props)), { value,
        onFocus,
        onBlur,
        onChange,
        warnings,
        label,
        required,
        info, placeholder: placeholder || 'No Placeholder', readOnly });
    return filteredProps;
};
const useOptions = (optionDef, queryKey) => {
    const client = (0, client_1.useApolloClient)();
    // TODO: I don't like this. Options within form dropdowns, probably shouldn't be reading the accessors.
    const { accessors } = (0, form_renderer_1.useFormDataMappingSources)();
    const { aggregateDefinitions } = (0, configContext_1.useConfig)();
    const { username, roles } = (0, UserInfoContext_1.useUserInfo)();
    const optionsProvider = (0, react_1.useCallback)(async (params, endCursor, searchText) => {
        var _a;
        if (optionDef.type === form_renderer_1.SimpleOptionType) {
            return {};
        }
        // TODO use default filtering and mandatory filtering to generate the query not here though
        else if (optionDef.type === form_renderer_1.AggregateLoaderType) {
            try {
                const dataLoader = optionDef;
                const aggregateSource = (accessors.STATE && accessors.STATE()) || {};
                const queryKey = (_a = aggregateDefinitions.find(d => d.name === dataLoader.aggregateType)) === null || _a === void 0 ? void 0 : _a.queryKey;
                if (!queryKey) {
                    console.error('No query key found for 1', dataLoader.aggregateType);
                    return [];
                }
                const graphQlQuery = (0, QueryDefinitionToGraphQLQuery_1.computeGraphQlQueryFromQueryDefinitionWithPagination)({
                    queryKey: queryKey,
                    queryDefinition: dataLoader.mandatoryFilter,
                    objectToMatchKeyWord: aggregateSource,
                    username,
                    userRoles: roles.map(role => role.name),
                    limit: DATA_COUNT_PER_PAGE,
                    after: endCursor,
                    searchText: searchText,
                });
                const items = await client
                    .query({
                    query: (0, client_2.gql) `
                ${graphQlQuery.query}
              `,
                })
                    .then(response => {
                    const nodes = response.data[`${queryKey}Connection`]['nodes'];
                    const pageInfo = response.data[`${queryKey}Connection`]['pageInfo'];
                    const totalCount = response.data[`${queryKey}Connection`]['totalCount'];
                    const metadata = (accessors.METADATA && accessors.METADATA()) || {};
                    if (metadata.hasOwnProperty('aggregateType') &&
                        metadata.aggregateType === dataLoader.aggregateType) {
                        return {
                            items: nodes.filter(({ id }) => id !== aggregateSource.id),
                            pageInfo: Object.assign(Object.assign({}, pageInfo), { totalCount: totalCount }),
                        };
                    }
                    return { items: nodes };
                })
                    .then(graphQlData => {
                    const data = ((graphQlData === null || graphQlData === void 0 ? void 0 : graphQlData.items) || []).map(({ label, id }) => ({
                        label,
                        value: id,
                    }));
                    return Object.assign(Object.assign({}, graphQlData), { items: data });
                });
                return items;
            }
            catch (e) {
                console.error(e);
                return {};
            }
        }
        else if (optionDef.type === form_renderer_1.UserLoaderType) {
            try {
                const dataLoader = optionDef;
                const userSource = (accessors.STATE && accessors.STATE()) || {};
                const queryKey = 'usersSelect';
                const graphQlQuery = (0, QueryDefinitionToGraphQLQuery_1.computeGraphQlQueryFromQueryDefinitionWithPagination)({
                    queryKey,
                    queryDefinition: dataLoader.mandatoryFilter,
                    objectToMatchKeyWord: userSource,
                    username,
                    userRoles: roles.map(role => role.name),
                    limit: DATA_COUNT_PER_PAGE,
                    after: endCursor,
                    searchText: searchText,
                });
                const items = await client
                    .query({
                    query: (0, client_2.gql) `
                ${graphQlQuery.query}
              `,
                })
                    .then(response => {
                    const nodes = response.data[`${queryKey}Connection`]['nodes'];
                    const pageInfo = response.data[`${queryKey}Connection`]['pageInfo'];
                    const totalCount = response.data[`${queryKey}Connection`]['totalCount'];
                    return { items: nodes, pageInfo: Object.assign(Object.assign({}, pageInfo), { totalCount: totalCount }) };
                })
                    .then(graphQlData => {
                    const data = ((graphQlData === null || graphQlData === void 0 ? void 0 : graphQlData.items) || []).map(({ label, id }) => ({
                        label,
                        value: id,
                    }));
                    return Object.assign(Object.assign({}, graphQlData), { items: data });
                });
                return items;
            }
            catch (e) {
                console.error(e);
                return {};
            }
        }
        else {
            return {};
        }
    }, [optionDef, client, aggregateDefinitions, accessors]);
    const valueOptionsProvider = (0, react_1.useCallback)(async (value) => {
        var _a;
        if (optionDef.type !== form_renderer_1.AggregateLoaderType)
            return [];
        const dataLoader = optionDef;
        const queryKey = (_a = aggregateDefinitions.find(d => d.name === dataLoader.aggregateType)) === null || _a === void 0 ? void 0 : _a.queryKey;
        if (!queryKey) {
            console.error('No query key found for 2', dataLoader.aggregateType);
            return [];
        }
        const graphQlQuery = (0, QueryDefinitionToGraphQLQuery_1.computeGraphQlQueryFetchAggregateTypeByIds)({
            queryKey,
            ids: Array.isArray(value) ? value : !(0, lodash_1.isNil)(value) ? [value] : [],
        });
        try {
            const items = await client
                .query({
                query: (0, client_2.gql) `
              ${graphQlQuery.query}
            `,
                variables: graphQlQuery.variables,
            })
                .then(response => {
                return response.data[queryKey].map(({ label, id }) => ({
                    label,
                    value: id,
                }));
            });
            return items;
        }
        catch (e) {
            console.error(e);
            return [];
        }
    }, [optionDef, client, aggregateDefinitions]);
    const options = optionDef.type === form_renderer_1.SimpleOptionType ? optionDef.items : undefined;
    const dataProvider = optionDef.type !== form_renderer_1.SimpleOptionType && optionDef.type !== form_renderer_1.DynamicLoaderType
        ? {
            optionsProvider,
            valueOptionsProvider,
        }
        : undefined;
    return {
        options,
        dataProvider,
    };
};
const useSelectFieldProps = (props) => {
    const { controlDefinition, errors, warnings } = props, moreProps = __rest(props, ["controlDefinition", "errors", "warnings"]);
    const { options, label, placeholder, required, info } = controlDefinition;
    const optionsList = useOptions(options);
    const filteredProps = Object.assign(Object.assign(Object.assign(Object.assign({}, optionsList), { label,
        placeholder,
        required,
        info }), getErrorAndWarningProps(props)), (moreProps || {}));
    return filteredProps;
};
const withTextFieldProps = (Component) => {
    return (props) => {
        const filteredProps = useFilterTextFieldProps(props);
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withTextFieldProps = withTextFieldProps;
const withTextFieldPropsComputed = (Component) => {
    return (props) => {
        const filteredProps = useFilterTextFieldProps(props);
        return react_1.default.createElement(Component, Object.assign({ computed: true }, filteredProps));
    };
};
exports.withTextFieldPropsComputed = withTextFieldPropsComputed;
const withNumberFieldProps = (Component) => {
    return (props) => {
        const filteredProps = useFilterTextFieldProps(props, 'number');
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withNumberFieldProps = withNumberFieldProps;
const withDateFieldProps = (Component) => {
    return (props) => {
        const { value, onChange, controlDefinition, warnings, readOnly } = props;
        const valueToUse = value && typeof value === 'number' ? (0, common_1.dateValueToDatePicker)(value) : null;
        const { label, placeholder, required, info } = controlDefinition;
        const filteredProps = Object.assign(Object.assign({ label,
            placeholder,
            required,
            info, value: valueToUse }, getErrorAndWarningProps(props)), { warnings, onChange: (date) => {
                onChange(date ? (0, common_1.datePickerToDateValue)(date) : null);
            }, readOnly });
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withDateFieldProps = withDateFieldProps;
const withSelectFieldProps = (Component) => {
    return (props) => {
        const filteredProps = useSelectFieldProps(props);
        return props.pending ? react_1.default.createElement(CircularProgress_1.default, { color: "primary" }) : react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withSelectFieldProps = withSelectFieldProps;
const withAggregateSelectorFieldProps = (Component) => {
    return (props) => {
        //const filteredProps = useSelectFieldProps(props);
        //return <Component {...filteredProps} />;
        const { controlDefinition, errors, warnings, value, onChange } = props, moreProps = __rest(props, ["controlDefinition", "errors", "warnings", "value", "onChange"]);
        const { label, placeholder, required, info, selectableAggregateTypes } = controlDefinition;
        const filteredProps = Object.assign(Object.assign({ value,
            onChange,
            label,
            placeholder,
            required,
            info,
            selectableAggregateTypes }, getErrorAndWarningProps(props)), (moreProps || {}));
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withAggregateSelectorFieldProps = withAggregateSelectorFieldProps;
const withRadioFieldProps = (Component) => {
    return (props) => {
        const { controlDefinition, readOnly, value, onChange } = props, moreProps = __rest(props, ["controlDefinition", "readOnly", "value", "onChange"]);
        const { options, required, label, placeholder, info } = controlDefinition;
        const optionsList = useOptions(options);
        const filteredProps = Object.assign(Object.assign(Object.assign(Object.assign({}, getErrorAndWarningProps(props)), optionsList), { value,
            onChange,
            readOnly,
            required,
            info,
            label,
            placeholder }), (moreProps || {}));
        return props.pending ? react_1.default.createElement(CircularProgress_1.default, { color: "primary" }) : react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withRadioFieldProps = withRadioFieldProps;
const withCheckboxProps = (Component) => {
    return (props) => {
        const selectFieldProps = useSelectFieldProps(props);
        return props.pending ? react_1.default.createElement(CircularProgress_1.default, { color: "primary" }) : react_1.default.createElement(Component, Object.assign({}, selectFieldProps, { multiSelect: true }));
    };
};
exports.withCheckboxProps = withCheckboxProps;
const withTimeFieldProps = (Component) => {
    return (props) => {
        const { value, onChange, controlDefinition, readOnly } = props;
        const { label, placeholder, required, info } = controlDefinition;
        const valueToUse = value && typeof value === 'number' ? (0, common_1.timeValueToTimePicker)(value) : null;
        const filteredProps = Object.assign(Object.assign({ value: valueToUse }, getErrorAndWarningProps(props)), { onChange: (time) => {
                onChange(time ? (0, common_1.timePickerToTimeValue)(time) : null);
            }, label,
            placeholder,
            required,
            info,
            readOnly });
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withTimeFieldProps = withTimeFieldProps;
const withCurrencyFieldProps = (Component) => {
    return (props) => {
        const textFieldProps = useFilterTextFieldProps(props, 'number');
        const filteredProps = Object.assign(Object.assign({}, textFieldProps), { InputProps: {
                startAdornment: react_1.default.createElement(InputAdornment_1.default, { position: "start" }, props.controlDefinition.currency),
            } });
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withCurrencyFieldProps = withCurrencyFieldProps;
const withTextHeaderProps = (Component) => {
    return (props) => {
        const { label } = props.controlDefinition;
        const filteredProps = {
            label,
        };
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withTextHeaderProps = withTextHeaderProps;
const withTextareaFieldProps = (Component) => {
    return (props) => {
        const textFieldProps = useFilterTextFieldProps(props);
        const filteredProps = Object.assign(Object.assign({}, textFieldProps), { multiline: true });
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withTextareaFieldProps = withTextareaFieldProps;
const getTypeFromFile = (file) => {
    const parts = file.split('.');
    switch (parts[parts.length - 1].toLowerCase()) {
        case 'jpg':
            return 'image/jpeg';
        case 'png':
            return 'image/png';
    }
    return 'image/jpeg'; // reasonable? Prolly not
};
const withMediaFieldProps = (Component) => {
    return (props) => {
        var _a;
        const { value, controlDefinition, getFile, removeFile, addFile, readOnly } = props;
        const [fileUrls, setFileUrls] = (0, react_1.useState)([]);
        const authState = (0, authContext_1.useAuthContext)();
        (0, react_1.useEffect)(() => {
            //any time value changes, check to see if we need a url based on id.
            //TODO: This is a mess. File handling is pretty bad right now. Most of this is to work around the lack of mime types
            if (value) {
                const localVal = Array.isArray(value) ? value : [value];
                localVal &&
                    localVal.forEach(val => {
                        if (!fileUrls.map(fileUrl => fileUrl.id).includes(val)) {
                            //then attempt to load the file into the url cache
                            //first try the local cache?
                            const possibleFile = getFile(val);
                            if (possibleFile) {
                                setFileUrls(current => [...current, { id: val, url: getUrl(possibleFile) }]);
                            }
                            else {
                                // then try the doc_api
                                authState.token &&
                                    authState.token().then(token => {
                                        const options = {
                                            headers: {
                                                Authorization: `Bearer ${token}`,
                                            },
                                        };
                                        fetch(`/media/v1/${val}`, options)
                                            .then(res => res.blob())
                                            .then(blob => {
                                            const file = new File([blob], val, { type: getTypeFromFile(val) });
                                            setFileUrls(current => [...current, { id: val, url: URL.createObjectURL(file) }]);
                                        });
                                    });
                            }
                        }
                    });
                // having this set of dependencies could cause this to be called more often than needed
            }
        }, [value, fileUrls, setFileUrls, authState, getFile]);
        const getUrl = (file) => {
            if (file && file.name) {
                return URL.createObjectURL(file);
            }
            if (lodash_1.default.isString(file)) {
                return file;
            }
            return null;
        };
        const files = Array.isArray(value)
            ? value === null || value === void 0 ? void 0 : value.map(val => {
                var _a;
                return ({
                    id: val,
                    file: getFile(val),
                    url: ((_a = fileUrls.find(entry => entry.id === val)) === null || _a === void 0 ? void 0 : _a.url) || '',
                });
            })
            : value
                ? [{ id: value, file: getFile(value), url: ((_a = fileUrls.find(entry => entry.id === value)) === null || _a === void 0 ? void 0 : _a.url) || '' }]
                : [];
        const filteredProps = Object.assign({ type: controlDefinition.type, required: !!controlDefinition.required, info: controlDefinition.info, addFiles: (files) => {
                files.forEach((fileOb) => {
                    addFile(fileOb.file);
                    //also add the url to the local cache
                    setFileUrls(current => [...current, { id: fileOb.id, url: getUrl(fileOb.file) }]);
                });
            }, removeFiles: (ids) => {
                ids.forEach(id => removeFile(id));
            }, files,
            value, min: controlDefinition.min || 0, max: controlDefinition.max || -1, label: controlDefinition.label, 
            // errors, TODO - not supported
            readOnly }, getErrorAndWarningProps(props));
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withMediaFieldProps = withMediaFieldProps;
const withFileFieldProps = (Component) => {
    return (props) => {
        var _a;
        const { value, controlDefinition, getFile, removeFile, addFile, readOnly } = props;
        const [fileUrls, setFileUrls] = (0, react_1.useState)([]);
        const authState = (0, authContext_1.useAuthContext)();
        (0, react_1.useEffect)(() => {
            //any time value changes, check to see if we need a url based on id.
            //TODO: This is a mess. File handling is pretty bad right now. Most of this is to work around the lack of mime types
            if (value) {
                const localVal = Array.isArray(value) ? value : [value];
                localVal &&
                    localVal.forEach(val => {
                        if (!fileUrls.map(fileUrl => fileUrl.id).includes(val.id)) {
                            //then attempt to load the file into the url cache
                            //first try the local cache?
                            const possibleFile = getFile(val.id);
                            if (possibleFile) {
                                setFileUrls(current => [...current, { id: val.id, url: getUrl(possibleFile) }]);
                            }
                            else {
                                // then try the doc_api
                                authState.token &&
                                    authState.token().then(token => {
                                        const options = {
                                            headers: {
                                                Authorization: `Bearer ${token}`,
                                            },
                                        };
                                        fetch(`/media/v1/${val.id}`, options)
                                            .then(res => res.blob())
                                            .then(blob => {
                                            const file = new File([blob], val.id, { type: getTypeFromFile(val.name) });
                                            setFileUrls(current => [...current, { id: val.id, url: URL.createObjectURL(file) }]);
                                            addFile(null, val.id, val.name);
                                        });
                                    });
                            }
                        }
                    });
                // having this set of dependencies could cause this to be called more often than needed
            }
        }, [value, fileUrls, setFileUrls, authState, getFile]);
        const getUrl = (file) => {
            if (file && file.name) {
                return URL.createObjectURL(file);
            }
            if (lodash_1.default.isString(file)) {
                return file;
            }
            return null;
        };
        const files = Array.isArray(value)
            ? value === null || value === void 0 ? void 0 : value.map(val => {
                var _a;
                return ({
                    id: val.id,
                    file: getFile(val.id) || { name: val.name },
                    url: ((_a = fileUrls.find(entry => entry.id === val.id)) === null || _a === void 0 ? void 0 : _a.url) || '',
                });
            })
            : value
                ? [
                    {
                        id: value.id,
                        file: getFile(value.id),
                        url: ((_a = fileUrls.find(entry => entry.id === value.id)) === null || _a === void 0 ? void 0 : _a.url) || '',
                    },
                ]
                : [];
        const filteredProps = Object.assign({ type: controlDefinition.type, required: !!controlDefinition.required, info: controlDefinition.info, addFiles: (files) => {
                files.forEach((fileOb) => {
                    addFile(fileOb.file);
                    //also add the url to the local cache
                    setFileUrls(current => [...current, { id: fileOb.id, url: getUrl(fileOb.file) }]);
                });
            }, removeFiles: (ids) => {
                ids.forEach(id => removeFile(id));
            }, files,
            value, min: controlDefinition.min || 0, max: controlDefinition.max || -1, label: controlDefinition.label, 
            // errors, TODO - not supported
            readOnly }, getErrorAndWarningProps(props));
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withFileFieldProps = withFileFieldProps;
const withBarcodeFieldProps = (Component) => {
    return (props) => {
        const { controlDefinition, readOnly, onChange, value, validationFn } = props;
        const { label, placeholder, required, type, info } = controlDefinition;
        const validator = validationFn
            ? (val, allValues) => {
                return validationFn(val, allValues, true); // adds true to the function to ignore whether or not the input has been touched when validating
            }
            : undefined;
        const filteredProps = Object.assign({ type,
            label,
            readOnly,
            required,
            info,
            onChange, value: value, placeholder: placeholder || '', validator: validator }, getErrorAndWarningProps(props));
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withBarcodeFieldProps = withBarcodeFieldProps;
const withLocationFieldProps = (Component) => {
    return (props) => {
        const { controlDefinition, readOnly, onChange, value, validationFn } = props;
        const { label, placeholder, type, required, info, multiplePoints } = controlDefinition;
        const validator = validationFn
            ? (val, allValues) => {
                return validationFn(val, allValues, true);
            }
            : undefined;
        const locationProps = Object.assign(Object.assign({ type,
            label,
            readOnly,
            required,
            info,
            multiplePoints, onChange: (val) => {
                if (val) {
                    if (Array.isArray(val)) {
                        const restructuredJson = val.map((point) => {
                            const arrayEntry = { location: {} };
                            arrayEntry.location = point;
                            return arrayEntry;
                        });
                        onChange(restructuredJson);
                    }
                    else {
                        onChange({ location: val });
                    }
                }
                else {
                    onChange(undefined);
                }
            } }, getErrorAndWarningProps(props)), { value: Array.isArray(value) ? value.map(x => x === null || x === void 0 ? void 0 : x.location) : (value === null || value === void 0 ? void 0 : value.location) || null, placeholder: placeholder || '', validator: validator });
        return react_1.default.createElement(Component, Object.assign({}, locationProps));
    };
};
exports.withLocationFieldProps = withLocationFieldProps;
const withPolylineFieldProps = (Component) => {
    return (props) => {
        const { controlDefinition, readOnly, onChange, value, validationFn } = props;
        const { label, placeholder, type, required, info } = controlDefinition;
        const validator = validationFn
            ? (val, allValues) => {
                return validationFn(val, allValues, true);
            }
            : undefined;
        const polylineProps = Object.assign(Object.assign({ type,
            label,
            readOnly,
            required,
            info, onChange: (val) => {
                if (val) {
                    onChange({ polyline: val });
                }
                else {
                    onChange(undefined);
                }
            } }, getErrorAndWarningProps(props)), { value: (value === null || value === void 0 ? void 0 : value.polyline) || null, placeholder: placeholder || '', validator: validator });
        return react_1.default.createElement(Component, Object.assign({}, polylineProps));
    };
};
exports.withPolylineFieldProps = withPolylineFieldProps;
//# sourceMappingURL=FormHelpers.js.map